import { getLang } from 'Cloud/Application/Lang';
import { mergeDeepLeft, mergeDeepWithKey } from 'ramda';

import type { ExtensionRecord, RawEditor } from '../editor.types';
import { getIconClass } from './get-icon-class';

type ComposeExtensionsFn = (editors: RawEditor[]) => ExtensionRecord;

export const composeExtensions: ComposeExtensionsFn = (editors: RawEditor[]) =>
    editors.reduce((acc, editor) => {
        const editExtensions = (editor.edit_extensions || []).reduce(
            (editExtHash, ext) => ({ ...editExtHash, [ext]: { editors: [editor.id] } }),
            {}
        );

        const createExtensions = (editor.create_extensions || []).reduce((createExtHash, ext) => {
            const creatorsDesc = acc?.[ext]?.creatorsDesc || {
                name: ext,
                icon: getIconClass(ext, 16, ''),
                text: getLang().get(`b-dropdown.create.${ext}`),
            };

            return { ...createExtHash, [ext]: { creatorsDesc } };
        }, {});

        return mergeDeepWithKey((k, l, r) => (k === 'editors' ? l.concat(r) : r), acc, mergeDeepLeft(editExtensions, createExtensions));
    }, {} as ExtensionRecord);
